export default {
  setPersonList(state, personList) {
    state.personList = personList
  }
}
